import $ from 'jquery';
import { invalidFormFieldLabelPositionHandler } from '../utils/utils';

function contactFormInit() {
  const form = $('#contactUsForm');
  if (form.length > 0) {
    form.parsley();
    initLimiter();
  }

  invalidFormFieldLabelPositionHandler('#contactUsForm');

  $('#contactUsForm input').each((i, el) => {
    const $val = $(el).val();
    if ($val === '') {
      $(el).removeClass('_has-value');
    } else {
      $(el).addClass('_has-value');
    }
  });
}

function initLimiter() {
  const messageField = document.querySelector('#contactUs-messageBody');
  const counterSpan = document.querySelector('#contactUsMsgCount');
  const limit = parseInt(counterSpan.textContent || '32000', 10);

  const setCount = () => {
    if (!(messageField && counterSpan)) {
      return;
    }

    let chars = messageField.value.length;

    if (chars > limit) {
      messageField.value = messageField.value.substr(0, limit);
      chars = limit;
    }

    chars = limit - chars;
    counterSpan.textContent = `${chars}`;
  };

  messageField.addEventListener('keyup', setCount);
  setCount();
}

$(() => {
  contactFormInit();
});
